import { ApiService } from "../../../model/Api.model";
import { AxiosInstance } from "axios";
import { ILeadsDatasetPricingPending } from "src/services/interface/pricing/ILeadsDatasetPricingPending";

enum LeadsDatasetPricingPending {
    get = '/'
}

export default class LeadsDatasetPricingPendingService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/pricing/leads/pricing/pending");
    }
    public getAllTrades = async (): Promise<IApiResponse<ILeadsDatasetPricingPending[]>> => await this.GET(LeadsDatasetPricingPending.get);
    public getById = async (id: number): Promise<any> => await this.GET(LeadsDatasetPricingPending.get + `${id}`);
}



// WEBPACK FOOTER //
// ./src/services/api/Pricing/leads-dataset-pricing-pending/LeadsDatasetPricingPending.service.ts